<template>
  <div class="container-fluid mt-5">
    <card>
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h3 class="mb-0">{{ $t("EQUIPMENT_TRANSFERS.EDIT_EQUIPMENT_TRANSFER") }}</h3>
        <base-button type="secondary" @click="goBack">
          {{ $t("COMMON.RETURN_TO_LIST") }}
        </base-button>
      </div>
      <equipment-transfer-form
        :transferModel="transfer"
        :loading="loading"
        :submitLabel="$t('COMMON.SAVE')"
        @submit="submit"
      />
    </card>
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import defaultTransfer from "./defaultEquipmentTransfer";
import EquipmentTransferForm from "./partials/EquipmentTransferForm.vue";

export default {
  name: "EditEquipmentTransferPage",
  components: { EquipmentTransferForm },
  data() {
    return {
      transfer: cloneDeep(defaultTransfer),
      loading: false,
    };
  },
  created() {
    this.getTransfer();
  },
  methods: {
    async getTransfer() {
      this.loading = true;
      try {
        await this.$store.dispatch("equipmentTransfers/get", {
          id: this.$route.params.id,
        });
        this.transfer =
          this.$store.getters["equipmentTransfers/transfer"] || cloneDeep(defaultTransfer);
      } finally {
        this.loading = false;
      }
    },
    async submit(payload) {
      this.loading = true;
      try {
        await this.$store.dispatch("equipmentTransfers/update", {
          data: payload,
        });
        const transfer = this.$store.getters["equipmentTransfers/transfer"];
        this.goToView(transfer.id);
      } finally {
        this.loading = false;
      }
    },
    goToView(id) {
      this.$router.push({ name: "View EquipmentTransfer", params: { id } });
    },
    goBack() {
      this.$router.push({ name: "List EquipmentTransfers" });
    },
  },
};
</script>
